import { getPartner } from './partners'
import { getEntity } from './_utils'

export function getReference (state, { id }) {
  const reference = getEntity('references')(state, { id })
  return reference.set('partner', getPartner(state, { id: reference.partner }))
}
